import { Injectable } from '@angular/core';

@Injectable()
export class BrowserService {
   isIE() {
      const ua = window.navigator.userAgent;
      return ua.indexOf('Trident/') > -1;
   }
}
